module.exports = __webpack_public_path__ + "static/img/3.8e2db7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting811/images/3.png
// module id = nVA0
// module chunks = 4